<!-- BEGIN #header -->
<div id="header" class="app-header" [attr.data-bs-theme]="this.appSettings.appHeaderInverse ? 'dark' : ''">
	<div class="navbar-header">
		<a href="javascript:;" class="navbar-brand"><img [src]="logo" width="25px">&nbsp; FPV <b
			class="text-info">&nbsp; UCh</b></a>
	</div>
	@if (environment.env != 'Production') {
		<div class="d-flex align-items-center">
			<div class="vertical-line"></div>
			<h5 class="navbar-brand badge" style="text-transform: uppercase;"><b class="text-info">{{ environment.env }}</b></h5>
		</div>
	}
	<div class="d-flex align-items-center">
		<div class="vertical-line"></div>
		@if (periodService.activePeriod(); as open) {
			<span class="navbar-brand badge mb-0" title="Periodo al que se asignan altas, bajas y transferencias">
				<b class="text-info">{{ periodService.activeLabel() }}</b>
				<span class="text-muted fw-normal ms-1">En curso</span>
			</span>
		} @else {
			<span class="navbar-brand badge mb-0">
				<b class="text-warning">Sin periodo abierto</b>
			</span>
		}
	</div>

	<div class="navbar-nav">
		<div class="navbar-item dropdown">
			<a href="javascript:;"
				class="navbar-link dropdown-toggle icon"
				[class.header-icon-muted]="nav.badgeCount() === 0"
				data-bs-toggle="dropdown"
				(click)="nav.hub.markAllRead()">
				<i class="fa fa-bell"></i>
				@if (nav.badgeCount() > 0) {
					<span class="badge header-badge header-badge-alert">{{ nav.noticesBadgeLabel() }}</span>
				}
			</a>
			<div class="dropdown-menu media-list dropdown-menu-end entity-dropdown">
				<div class="sticky-header">
					<div class="dropdown-header d-flex justify-content-between align-items-center">
						<div>
							NOTIFICACIONES
							@if (nav.hub.unreadCount() > 0) {
								<span class="badge bg-primary ms-1">{{ nav.hub.unreadCount() }} nuevas</span>
							}
						</div>
					</div>
				</div>

				@if (nav.recentNotices().length > 0) {
					<div class="dropdown-header text-muted fs-11 py-1">Avisos recientes</div>
					@for (notice of nav.recentNotices(); track notice.key) {
						<a href="javascript:;" (click)="nav.hub.open(notice)" class="dropdown-item media"
							[class.fw-semibold]="!notice.read">
							<div class="media-left">
								<i class="fa fa-bolt media-object fs-sm text-black bg-gray-400"></i>
							</div>
							<div class="media-body">
								<h6 class="media-heading text-dark mb-0">
									@if (!notice.read) {
										<span class="notice-dot"></span>
									}
									{{ notice.title }}
								</h6>
								<p class="fs-11 mb-0 text-dark">{{ notice.message }}</p>
								<div class="text-muted fs-10">{{ notice.at | date:'short' }}</div>
							</div>
						</a>
					}
				}

				@if (nav.pendingRequests().length > 0) {
					<div class="dropdown-header text-muted fs-11 py-1">Pendientes de tus roles</div>
					@for (item of nav.pendingRequests(); track item.request.uuid) {
						<a href="javascript:;" (click)="nav.openPending(item)" class="dropdown-item media">
							<div class="media-left">
								<i [class]="nav.processIcon(item) + ' media-object fs-sm text-black bg-gray-400'"></i>
							</div>
							<div class="media-body">
								<h6 class="media-heading text-dark">{{ nav.processName(item) }}</h6>
								<p class="fs-11 mb-0 text-dark">{{ nav.partyLabel(item) }}</p>
								<div class="text-muted fs-10">{{ nav.pendingRoleLabel(item) }} · {{ nav.createdAt(item) | date:'short' }}</div>
							</div>
						</a>
					}
				}

				@if (nav.recentNotices().length === 0 && nav.pendingRequests().length === 0) {
					<div class="dropdown-item text-center p-3 text-muted">
						<i class="fa fa-check-circle fa-2x d-block mb-2 text-success"></i>
						No hay notificaciones pendientes
					</div>
				} @else {
					<div class="dropdown-footer text-center">
						<a href="javascript:;" (click)="nav.openInbox()" class="text-decoration-none">Ver bandeja de solicitudes</a>
					</div>
				}
			</div>
		</div>

		@if (nav.rolesList().length > 1) {
		<div class="navbar-item dropdown">
			<a href="javascript:;" class="navbar-link dropdown-toggle icon"
				[title]="nav.roleSelectedLabel()"
				data-bs-toggle="dropdown">
				<i class="fa fa-user-tag"></i>
				<span class="badge header-badge header-badge-entity">{{ nav.rolesBadgeLabel() }}</span>
			</a>
			<div class="dropdown-menu media-list dropdown-menu-end entity-dropdown">
				<div class="sticky-header">
					<div class="dropdown-header d-flex justify-content-between align-items-center">
						<span>CAMBIAR ROL ({{ nav.rolesList().length }})</span>
					</div>
				</div>

				@for (r of nav.rolesList(); track r.id) {
				<a href="javascript:;" (click)="nav.changeRole(r)" class="dropdown-item media"
					[class.active]="nav.isActiveRole(r)">
					<div class="media-left">
						<i class="fa fa-user-tag media-object text-black bg-gray-500"></i>
					</div>
					<div class="media-body">
						<h6 class="media-heading">{{ r.displayName || r.description || r.name }}</h6>
						@if (nav.isActiveRole(r)) {
						<div class="text-info fs-11">Rol activo</div>
						}
					</div>
				</a>
				}
			</div>
		</div>
		}

		<div class="navbar-item navbar-user dropdown">
			<a href="javascript:;" class="navbar-link dropdown-toggle d-flex align-items-center"
				data-bs-toggle="dropdown">
				@if (profilePhotoURL) {
				<img [src]="profilePhotoURL" alt="profilePhoto" />
				}

				<span>
					<span>{{ userData?.displayName }}</span>
					<b class="caret"></b>
				</span>
			</a>
			<div class="dropdown-menu dropdown-menu-end me-1">
				<a href="https://myworkaccount.microsoft.com/" class="dropdown-item">Mi Cuenta</a>
				<a href="javascript:;" (click)="logout()" class="dropdown-item">Cerrar Sesión</a>
			</div>
		</div>
	</div>
</div>
